import { gql } from "graphql-tag"

import blog from "./blog"
import contests from "./contests"
import critics from "./critics"
import eightLeggedFreak from "./eightLeggedFreak"
import emails from "./emails"
import forum from "./forum"
import homeVideoReviews from "./homeVideoReviews"
import homeVideos from "./homeVideos"
import login from "./login"
import mas from "./mas"
import news from "./news"
import newsletters from "./newsletters"
import socials from "./socials"
import vendors from "./vendors"

const mutation = gql`
  ${blog}
  ${contests}
  ${critics}
  ${emails}
  ${eightLeggedFreak}
  ${forum}
  ${homeVideoReviews}
  ${homeVideos}
  ${login}
  ${mas}
  ${news}
  ${newsletters}
  ${socials}
  ${vendors}
`

export default mutation
